require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year.json") })
        }
      }, "path---research-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year!./.cache/json/research-ri-muhc-researchers-led-one-of-quebec-science-magazines-top-10-discoveries-of-the-year.json
// module id = 489
// module chunks = 231608221292675